import { CallAPI } from "../utils/api";

export async function AddTodo(todo, date, priority) {
  const data = {
    todo: todo,
    date: date,
    priority: priority,
  };
  return CallAPI(
    `/addTodo`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
    true
  );
}

export async function GetTodos(date) {
  return CallAPI(
    `/getTodos/${date}`,
    {
      method: "GET",
    },
    true
  );
}

export async function UpdateTodoStatus(id, done, date) {
  const data = {
    done: done,
    doneAt: date,
  };  
  return CallAPI(
    `/updateTodoStatus/${id}`,
    {
      method: "PATCH",
      body: JSON.stringify(data),
    },
    true
  );
}

export async function DeleteTodo(id) {
  return CallAPI(
    `/deleteTodo/${id}`,
    {
      method: "DELETE",
    },
    true
  );
}


export async function EditTodo(id, todo, date, priority) {
  const data = {
    todo: todo,
    date: date,
    priority: priority,
  };  
  return CallAPI(
    `/editTodo/${id}`,
    {
      method: "PATCH",
      body: JSON.stringify(data),
    },
    true
  );
}

